import { render, staticRenderFns } from "./SegmentedList.vue?vue&type=template&id=302131fc&scoped=true&"
import script from "./SegmentedList.vue?vue&type=script&lang=js&"
export * from "./SegmentedList.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedList.vue?vue&type=style&index=0&id=302131fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302131fc",
  null
  
)

export default component.exports